__turbopack_context__.v({
  "item-render-subtitle": "PostSearch-module__Fn9m8q__item-render-subtitle",
  "item-subtitle": "PostSearch-module__Fn9m8q__item-subtitle",
  "list-item": "PostSearch-module__Fn9m8q__list-item",
  "section-image": "PostSearch-module__Fn9m8q__section-image",
  "section-items": "PostSearch-module__Fn9m8q__section-items",
});
